import { useSyncExternalStore } from "react";
import type { EditorStore, EditorState } from "../lib/store.ts";
export const useStore = (s: EditorStore): EditorState => useSyncExternalStore(s.subscribe, s.getState);
